import { useContext } from "react";
import MessagesContext from "../context/MessagesContext";

function useShowMessages() {
  const {
    message,
    messageSeverity,
    showSnackbar,
    showMessage,
    setShowSnackbar
  } = useContext(MessagesContext);
  return { message, messageSeverity, showSnackbar, showMessage, setShowSnackbar };
}

export default useShowMessages;
